/* eslint-disable @department-of-veterans-affairs/prefer-button-component */
import { toggleLoginModal } from 'platform/site-wide/user-nav/actions';
import { isLoggedIn } from 'platform/user/selectors';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

const SignInAlert = () => {
  const loggedIn = useSelector(isLoggedIn);
  const dispatch = useDispatch();
  return (
    !loggedIn && (
      <va-alert status="info" slim>
        <p className="vads-u-margin-top--0">
          It may take some time to complete this form. Sign in to save your
          progress. If you sign in, you can also check the status of your
          application after you submit it.
        </p>
        <p>
          <strong>
            If you’re currently enrolled and need to update your information
          </strong>
          , you must sign in.
        </p>
        <button
          type="button"
          className="va-button-link"
          onClick={() => dispatch(toggleLoginModal(true))}
        >
          Sign in to start your application
        </button>
      </va-alert>
    )
  );
};

export default SignInAlert;
